

 <ng-container *ngIf="convertedBlob && !isLoading && isDownload">
  <app-download-button [isDownload]="isDownload"  [blob]="convertedBlob" [fileName]="fileName" [selectedDownloadHeader]="selectedDownloadHeader" [selectedDownloadButton]="selectedDownloadButton" [selectedIconIdentifireRequest]="selectedIconIdentifireRequest" (dataEmitter)="receiveData($event)" (iconSelected)="downloadIconSelected($event)" [splitFrom]="splitFrom" [splitTo]="splitTo"></app-download-button>
</ng-container>

<!-- File Upload Control -->
<div *ngIf="showFileUpload">
  <div class="main-wrapper">
    <div class="main-workarea">
        <div class="container">
            <div class="text-center top_header">
                <h1 class="heading-title">{{selectedHeader}}</h1>
                <span class="sub-title">{{selectedSubHeader}}</span>
                <app-showreview [reviews]="Review"></app-showreview>
            </div>
            
            <!-- <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div> -->
            <!-- Error Message -->
            <div *ngIf="visible" class="filetypeerrorpopup">
              {{ errorMessage }}
            </div>
            
            
               
         
            <div class="uploading_bar mt-4"  *ngIf="!cIsWeblink">
                <app-filedraganddrop (errorMessage)="handleErrorMessage($event)"   [selectedHeader]="selectedHeader" [selectedFileExtention]="selectedFileExtention" (filesUploaded)="onFileSelected($event)"></app-filedraganddrop>
            </div>
           
             <app-ocr-pdf-content *ngIf="isOcr"></app-ocr-pdf-content>
            <app-compress-pd-content *ngIf="isCompress"></app-compress-pd-content>
            <app-pptx-pdf-content *ngIf="isPptx"></app-pptx-pdf-content>
            <app-word-pdf-content *ngIf="IsWordtoPdf"></app-word-pdf-content>
            <app-exce-pdf-content *ngIf="IsExceltoPdf"></app-exce-pdf-content>
            <app-image-pdf-content *ngIf="IsImagetoPdf"></app-image-pdf-content>
            <app-pdf-image-content *ngIf="IsPdftoImage"></app-pdf-image-content>
            <app-word-png-content *ngIf="isWordtoPng"></app-word-png-content>
            <app-pdf-excel-content *ngIf="IsPdfToExcel"></app-pdf-excel-content>
            <app-watermark-pdf-content *ngIf="IsWatermark"></app-watermark-pdf-content>
            <app-protect-pdf-content *ngIf="IsProtectPdf"></app-protect-pdf-content>
           <app-unlock-pdf-content *ngIf="IsUnlock"></app-unlock-pdf-content>
            <app-pdf-word-content *ngIf="isPdftoword"></app-pdf-word-content>
            <app-split-content *ngIf="IsSplit"></app-split-content>
           <app-merge-pdf-content *ngIf="(selectedIconIdentifireRequest==='merge')"></app-merge-pdf-content>
           
            <div class="uploading_bar mt-4"  *ngIf="cIsWeblink">
              <div class="uploading_bar_btn me-3">
                <label style="cursor: pointer" class="uploader_btn"  (click)="openUrlModal()">{{selectedButtonName}}</label>
                 <app-html-pdf-content *ngIf="Ishtmltopdf"></app-html-pdf-content>
             <app-html-image-content *ngIf="Ishtmltoimage"></app-html-image-content>
              </div> 
              
          </div>
            <!-- <div class="uploader_droptxt">or drop PDFs here</div> -->
        </div>
    </div>
</div>

   
  
 
 
</div>
<div *ngIf="isLoading" class="loader-container">
  <!-- <div class="spinner"></div> -->
  <app-loader [isLoading]="isLoading"></app-loader>
</div>

<!-- Modal Structure -->
<div id="urlModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="urlModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
      <div class="modal-content">
          <div class="modal-header">
              <!-- <h4  id="urlModalLabel">Add a Web Link to convert from</h4> -->
              <h4 id="urlModalLabel">
                Add a Web Link to convert from 
                <span>{{ selectedIconIdentifireRequest === 'htmltoimage' ? 'HTML to Image' : selectedIconIdentifireRequest === 'htmltopdf' ? 'HTML to PDF' : '' }}</span>
              </h4>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div *ngIf="visible" class="filetypeerrorpopup">
            {{ errorMessage }}
          </div>
          <div class="modal-body">
              <div class="form-group">
                <!-- <div>{{errorMessage}}</div> -->
                  <!-- <label for="urlInput">URL</label> -->
                  <label for="urlInput"><h6>Website URL</h6></label>
                  <input type="text" id="urlInput" #textInput class="form-control" placeholder="Enter the website URL here">
              </div>
          </div>
          <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn common-btn mt-3" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary btn common-btn mt-3" (click)="addUrl(textInput.value)" >Add</button>
              <!-- (click)="addUrl()" -->
          </div>
      </div>
  </div>
</div>



<div *ngIf="(fileUploaded  && file) || ((fileUploaded  && HtmltoPdfRequest) || (fileUploaded  && HtmltoPdfRequest))">
  <div class="main-wrapper" *ngIf="!isConvertClicked">
    <div class="main-workarea" >
  <!-- PDF Viewer can be included here -->
  <div class="container">
    <div class="upload-container" *ngIf="(selectedIconIdentifireRequest==='merge')">
        <!-- (click)="showInfo()" -->
       
            <button class="info-icon-tooltip" onclick="window.location.href='/blog-pdf-merge'">
              <i class="fa fa-info-circle"></i>
              <span class="tooltip-text">Click to view all features of the Merge PDF tool.</span>
            </button>
        
        <button class="sort-icon custom-tooltip" (click)="toggleSort()">
            <i [ngClass]="[
            sortAsc ? 'fas fa-sort-alpha-down' : 'fas fa-sort-alpha-up',
            sortIconAnimate ? 'sort-effect' : ''
          ]"></i>
            <span class="tooltip-text">Sort by file name</span>
          </button>
          
        <!-- Plus Icon to trigger file input -->
        <button class="custom-plus-icon-tooltip" (click)="fileInput.click()">
            <i class="fa fa-plus"></i>
          <span class="tooltip-text">Add more files</span>
        </button>
      
        <!-- Hidden File Input -->
        <input 
          type="file" 
          #fileInput 
          (change)="onManualFileSelected($event)" 
          multiple 
          style="display: none;" 
          accept=".pdf"
        />
      </div>
    <div class="pdf-file_area">
        <div class="marge-pdf-wrapper">
            <!-- <input type="file" (change)="onManualFileSelected($event)" multiple /> -->
         
    <div class="pdf-file">



      <!-- <app-pdf-area-selector [file]="file!" [files]="files1!" [webUrl]="webUrl!" ></app-pdf-area-selector> -->
    <app-pdf-area-selector
      *ngIf="showPdfSelector && (file || files1 || webUrl)"
      [file]="file!"
      [files]="files1"
      [newfiles]="files2"
      [webUrl]="webUrl!"
      (updatedData)="onUpdatedData($event)"
      (updatedFiles)="onUpdatedFiles($event)"
      (allFilesRemoved)="handleAllFilesRemoved()"
      >
    </app-pdf-area-selector> 
    </div>   
</div> 




    </div>    
    </div>
   
    </div>


<!-- <ng-container *ngIf="fileUploaded && !isLoading && !convertedBlob && !isSideToolBar"> -->
  <div class="tool_sidebar sidebar-active" id="toolSidebar" *ngIf="!isMobile || selectedIconIdentifireRequest !== 'merge'" >
    <div class="sidebar_option_panel sidebar-active">
        <div class="sidebar_option_panel_title">
           <label [innerText]="cselectedHeader"></label> 
        </div>
        <div *ngIf="isWordtoPng" class="info multiple" >
            Your file has been uploaded successfully!  <br>
            Click ‘Convert to PNG’ to get your converted file instantly.
        </div>
        <!-- class="info multiple" -->
        <div *ngIf="(selectedIconIdentifireRequest==='merge')" >
            <div class="pdf-merge-summary">
                <ul>
                    <li>📂 Add multiple PDF files for merging</li>
                    <li>🔢 Sort files by name before merging</li>
                    <li>🔄 Rotate entire files or individual pages before merging</li>
                    <li>🔍 Zoom in/out to preview pages</li>
                    <li>🗑️ Delete specific pages while zoomed in</li>
                    <li>📄 Navigate between pages easily</li>
                    <li>↔️ Reorder pages by drag-and-drop</li>
                    <li>🗑️ Delete entire files from the list</li>
                </ul>
              </div>
        </div>
        <div *ngIf="IsWatermark">
            <div *ngIf="visible" class="filetypeerrorpopup1">
                {{ errorMessage }}
              </div>
          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <button class="nav-link active" id="nav-text-tab" data-bs-toggle="tab" data-bs-target="#nav-text" type="button" role="tab" aria-controls="nav-text" aria-selected="true" (click)="onTabClick('text')">
                    <svg width="53px" height="42px" viewBox="0 0 53 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="----↳-PDF/IMG---Watermark" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Watermark" transform="translate(-1084.000000, -157.000000)" fill="#161616">
                                <g id="A-Text" transform="translate(1084.000000, 157.000000)">
                                    <path
                                        d="M1.134,37 L51.866,37 C52.4922909,37 53,37.5077091 53,38.134 L53,40.4462469 C53,41.0725378 52.4922909,41.5802469 51.866,41.5802469 L1.134,41.5802469 C0.507709094,41.5802469 -3.03192595e-15,41.0725378 -3.10862447e-15,40.4462469 L0,38.134 C-7.66985154e-17,37.5077091 0.507709094,37 1.134,37 Z"
                                        id="Rectangle-23"
                                    ></path>
                                    <path
                                        d="M24.8461538,0 L13,30.6043771 L17.8461538,30.6043771 L20.2584615,24.0462963 L33.72,24.0462963 L36.1323077,30.6043771 L40.9784615,30.6043771 L29.1538462,0 L24.8461538,0 L24.8461538,0 Z M21.8738462,19.6742424 L27,5.83669192 L32.1261538,19.6742424 L21.8738462,19.6742424 L21.8738462,19.6742424 Z"
                                        id="Shape"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                    <div class="option__image__item__title">Place text</div>
                </button>
                <button class="nav-link" id="nav-image-tab" data-bs-toggle="tab" data-bs-target="#nav-image" type="button" role="tab" aria-controls="nav-image" aria-selected="false" (click)="onTabClick('image')">
                    <svg width="53px" height="43px" viewBox="0 0 53 43" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="----↳-PDF/IMG---Watermark" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Watermark" transform="translate(-1306.000000, -157.000000)" fill="#7D7D7D">
                                <g id="IMAGE" transform="translate(1306.000000, 157.000000)">
                                    <path
                                        d="M1.134,37.4650673 L51.866,37.4650673 C52.4922909,37.4650673 53,37.9727764 53,38.5990673 L53,40.9113143 C53,41.5376052 52.4922909,42.0453143 51.866,42.0453143 L1.134,42.0453143 C0.507709094,42.0453143 -3.03192595e-15,41.5376052 -3.10862447e-15,40.9113143 L0,38.5990673 C-7.66985154e-17,37.9727764 0.507709094,37.4650673 1.134,37.4650673 Z"
                                        id="Rectangle-23"
                                    ></path>
                                    <path
                                        d="M1.134,0.46506734 L51.866,0.46506734 C52.4922909,0.46506734 53,0.972776434 53,1.59906734 L53,3.91131425 C53,4.53760516 52.4922909,5.04531425 51.866,5.04531425 L1.134,5.04531425 C0.507709094,5.04531425 -3.03192595e-15,4.53760516 -3.10862447e-15,3.91131425 L0,1.59906734 C-7.66985154e-17,0.972776434 0.507709094,0.46506734 1.134,0.46506734 Z"
                                        id="Rectangle-23-Copy-3"
                                    ></path>
                                    <path
                                        d="M0,38.2106123 L3.55271368e-15,2.80993796 C3.55271368e-15,2.21107657 0.507709094,1.72560349 1.134,1.72560349 L3.44624691,1.72560349 C4.07253782,1.72560349 4.58024691,2.21107657 4.58024691,2.80993796 L4.58024691,38.2106123 C4.58024691,38.8094737 4.07253782,39.2949468 3.44624691,39.2949468 L1.134,39.2949468 C0.507709094,39.2949468 0,38.8094737 0,38.2106123 Z"
                                        id="Rectangle-23-Copy"
                                    ></path>
                                    <path
                                        d="M48.3549383,38.3159181 L48.3549383,2.91524374 C48.3549383,2.31638234 48.8626474,1.83090926 49.4889383,1.83090926 L51.8011852,1.83090926 C52.4274761,1.83090926 52.9351852,2.31638234 52.9351852,2.91524374 L52.9351852,38.3159181 C52.9351852,38.9147794 52.4274761,39.4002525 51.8011852,39.4002525 L49.4889383,39.4002525 C48.8626474,39.4002525 48.3549383,38.9147794 48.3549383,38.3159181 Z"
                                        id="Rectangle-23-Copy-2"
                                    ></path>
                                    <path
                                        d="M31.6923782,15.2520818 L45.7032728,33.6111851 C45.7843565,33.7174326 45.7639571,33.8692945 45.6577095,33.9503782 C45.6155337,33.982565 45.5639492,34 45.5108946,34 L17.4891054,34 C17.3554525,34 17.2471054,33.8916529 17.2471054,33.758 C17.2471054,33.7049454 17.2645404,33.6533609 17.2967272,33.6111851 L31.3076218,15.2520818 C31.3887055,15.1458342 31.5405674,15.1254349 31.6468149,15.2065185 C31.6639658,15.2196074 31.6792894,15.2349309 31.6923782,15.2520818 Z"
                                        id="Rectangle-4"
                                    ></path>
                                    <path
                                        d="M18.6317832,21.1631602 L28.7772059,33.7241597 C28.8359913,33.7969416 28.8246448,33.9035979 28.751863,33.9623832 C28.7217275,33.9867234 28.6841601,34 28.6454227,34 L8.35457733,34 C8.2610203,34 8.18517733,33.924157 8.18517733,33.8306 C8.18517733,33.7918625 8.1984539,33.7542952 8.2227941,33.7241597 L18.3682168,21.1631602 C18.4270021,21.0903783 18.5336584,21.0790319 18.6064403,21.1378173 C18.6157603,21.145345 18.6242555,21.1538402 18.6317832,21.1631602 Z"
                                        id="Rectangle-4-Copy"
                                    ></path>
                                    <circle id="Oval-8" cx="14.5" cy="13.5" r="3.5"></circle>
                                </g>
                            </g>
                        </g>
                    </svg>
                    <div class="option__image__item__title">Place image</div>
                </button>
            </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
            <div class="comment-form tab-pane fade show active p-3" id="nav-text" role="tabpanel" aria-labelledby="nav-text-tab" tabindex="0">
                <div class="form-group mb-3">
                    <div class="option__title">Text:</div>
                    <div class="tab-content-text">
                        <input type="text" [(ngModel)]="waterMarkText" class="form-control" placeholder="Watermark Text" />
                    </div>
                </div>
                <div class="form-group">
                    <div class="option__title">Position:</div>
                    <div class="tab-content-text">
                        <select class="form-select" aria-label="Default select example" [(ngModel)]="selectedPosition">
                            <option *ngFor="let position of positions" [value]="position.id">
                              {{ position.name }}
                            </option>
                          </select>
                        <!-- <select class="form-select" aria-label="Default select example">
                            <option selected="">Select Position</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                        </select> -->
                    </div>
                </div>
            </div>
            <div class="comment-form tab-pane fade p-3" id="nav-image" role="tabpanel" aria-labelledby="nav-image-tab" tabindex="0">
                <div class="picture-container">
                    <label class="label me-3" for="input">Please add a picture</label>
                  
                  
                    <button id="processTask" data-toggle="tooltip" data-bs-placement="right" class="btn btn_process" data-title="Please Add watermark" aria-label="Please Add watermark" data-bs-original-title="Please Add watermark">
                      Add watermark
                      <span>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" width="24" height="24" fill="#FFF" fill-rule="evenodd">
                              <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-2c6.075 0 11-4.925 11-11S19.075 2 13 2 2 6.925 2 13s4.925 11 11 11z" fill-rule="nonzero"></path>
                              <path
                                  d="M18.684 13.105a.55.55 0 0 1-.148.378l-5.263 5.263a.55.55 0 0 1-.378.148.54.54 0 0 1-.526-.526V15.21H7.842a.54.54 0 0 1-.526-.526v-3.158A.54.54 0 0 1 7.842 11h4.526V7.842a.52.52 0 0 1 .526-.526c.148 0 .28.066.395.164l5.247 5.247a.55.55 0 0 1 .148.378z"
                              ></path>
                          </svg>
                      </span>
                  </button>
                  <div class="file btn btn-lg position-relative">
                    Upload
                    <input (change)="onWaterMarkFileSelected($event)" name="input" id="file1" type="file"  />
                </div>
                  <!-- <div class="input">
                    <input  (change)="onWaterMarkFileSelected($event)" name="input" id="file1" type="file" />
                </div> -->
                </div>
                
                <div class="form-group">
                    <div class="option__title">Position:</div>
                    <div class="tab-content-text">
                        <select class="form-select" aria-label="Default select example">
                            <option *ngFor="let position of positions" [value]="position.id">
                              {{ position.name }}
                            </option>
                          </select>
                        <!-- <select class="form-select" aria-label="Default select example">
                            <option selected>Select Position</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                        </select> -->
                    </div>
                </div>
            </div>
        </div>
       
        </div>
        <div *ngIf="IsSplit">
        <div class="option__panel__content">
            <div class="option__title">Range mode:</div>
            <ul class="option__image">
                <li class="option__image__item"
                [ngClass]="{'option--active': activeMode === 'default'}" 
                 data-name="split_mode" data-value="ranges" (click)="splittoggleDiv('default')">
                    <div class="option__image__item__title">Default</div>
                </li>
                <li class="option__image__item"
                [ngClass]="{'option--active': activeMode === 'extract'}" 
                data-name="split_mode" data-value="fixed_range" (click)="splittoggleDiv('extract')">
                    <div class="option__image__item__title">Extract</div>
                </li>
                <li class="option__image__item"
                [ngClass]="{'option--active': activeMode === 'interval'}" 
                data-name="split_mode" data-value="fixed_range" (click)="splittoggleDiv('interval')">
                  <div class="option__image__item__title">Interval</div>
              </li>
            </ul>
        
        <div *ngIf="IsSplitDefaultMode" class="option__panel__content info multiple">Default mode split each page separately</div>
        


        <div class="formarea ranges" *ngIf="IsSplitIntervalMode">
          <div class="title4">
            Splitting intervals
          </div>
          <div class="form__group__container mt-3">
              <div class="form__group form__group--boxed">
                  <label>Split after</label>
                  <input class="input option rangefrom" type="number" value="1" [(ngModel)]="splitAfter" />
              </div>
          </div>
      </div>

        <div class="formarea ranges" *ngIf="IsSplitExtractMode">
            <div class="title4">
                Range
            </div>
            <div class="form__group__container mt-3">
                <div class="form__group form__group--boxed">
                    <label>from page</label>
                    <input class="input option rangefrom" type="number" value="1" [(ngModel)]="splitFrom" />
                </div>
                <div class="form__group form__group--boxed">
                    <label>to</label>
                    <input class="input option rangeto" type="number" value="1" [(ngModel)]="splitTo"/>
                </div>
            </div>
        </div>
      </div>


        </div>
          <div class="tab-content" id="nav-tabContent" *ngIf="(IsPassword || IsWebUrl || IsSplit)">
            <div class="comment-form tab-pane fade show active p-3" id="nav-text" role="tabpanel" aria-labelledby="nav-text-tab" tabindex="0">
                <div class="form-group mb-3">
                    <div class="option__title"   > {{subSubHeater}}:</div>
                    <div *ngIf="visible" class="filetypeerrorpopup1">
                      {{ errorMessage }}
                    </div>
                    <div class="tab-content-text" *ngIf="!IsSplit">
                        <div class="input-group" *ngIf="!IsWebUrl">
                            <input 
                              class="form-control" 
                              [type]="IsWebUrl ? 'text' : (isPasswordVisible ? 'text' : 'password')" 
                              [(ngModel)]="inputText" 
                              [disabled]="IsWebUrl" />
                            
                            <!-- Eye icon for toggling password visibility -->
                            <!-- <div class="input-group-append" > -->
                              <span 
                                class="input-group-text" 
                                (click)="togglePasswordVisibility()" 
                                style="cursor: pointer;">
                                <i [class]="isPasswordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                              </span>
                            <!-- </div> -->
                          </div>
                          <div *ngIf="IsWebUrl">
                      <input class="form-control" type="text" [(ngModel)]="inputText" [disabled]="IsWebUrl" />
                         </div>
                      <!-- <input class="form-control" type="text"  [(ngModel)]="inputText"  [attr.disabled]="IsWebUrl ? true : null" /> -->
                    </div>
                    
                </div>
              
            </div>
        </div>
        
    </div>
  
    <app-convert-button 
     [file]="file!" 
    (convert)="onConvert()"
    >
    <button
       
        class="btn btn-success btn-block"
        (click)="convertButton.convertFile()"
        [disabled]="!file"
        id="processTask"
        data-toggle="tooltip"
        data-bs-placement="right"
        class="btn btn_process"
        data-title="Please Select more PDF File"
        aria-label="Please Select more PDF File"
        data-bs-original-title="Please Select more PDF File"
    >
        <span id="processTaskTextBtn">{{cselectedButtonName}}</span>
        <span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" width="24" height="24" fill="#FFF" fill-rule="evenodd">
                <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-2c6.075 0 11-4.925 11-11S19.075 2 13 2 2 6.925 2 13s4.925 11 11 11z" fill-rule="nonzero"></path>
                <path
                    d="M18.684 13.105a.55.55 0 0 1-.148.378l-5.263 5.263a.55.55 0 0 1-.378.148.54.54 0 0 1-.526-.526V15.21H7.842a.54.54 0 0 1-.526-.526v-3.158A.54.54 0 0 1 7.842 11h4.526V7.842a.52.52 0 0 1 .526-.526c.148 0 .28.066.395.164l5.247 5.247a.55.55 0 0 1 .148.378z"
                ></path>
            </svg>
        </span>
    </button>
  </app-convert-button>

<!-- </ng-container> -->

 

  </div>
  <ng-container *ngIf="isMobile && selectedIconIdentifireRequest==='merge'" class="sidebar-active">
    <app-convert-button 
     [file]="file!" 
     class="sidebar-active"
    (convert)="onConvert()"
    >
    <button
       
        class="btn btn-success btn-block"
        (click)="convertButton.convertFile()"
        [disabled]="!file"
        id="processTask"
        data-toggle="tooltip"
        data-bs-placement="right"
        class="btn btn_process"
        data-title="Please Select more PDF File"
        aria-label="Please Select more PDF File"
        data-bs-original-title="Please Select more PDF File"
    >
        <span id="processTaskTextBtn">{{cselectedButtonName}}</span>
        <span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" width="24" height="24" fill="#FFF" fill-rule="evenodd">
                <path d="M13 26C5.82 26 0 20.18 0 13S5.82 0 13 0s13 5.82 13 13-5.82 13-13 13zm0-2c6.075 0 11-4.925 11-11S19.075 2 13 2 2 6.925 2 13s4.925 11 11 11z" fill-rule="nonzero"></path>
                <path
                    d="M18.684 13.105a.55.55 0 0 1-.148.378l-5.263 5.263a.55.55 0 0 1-.378.148.54.54 0 0 1-.526-.526V15.21H7.842a.54.54 0 0 1-.526-.526v-3.158A.54.54 0 0 1 7.842 11h4.526V7.842a.52.52 0 0 1 .526-.526c.148 0 .28.066.395.164l5.247 5.247a.55.55 0 0 1 .148.378z"
                ></path>
            </svg>
        </span>
    </button>
  </app-convert-button>
</ng-container>
</div>
  
  
   
  
   
  
   
  